import React, { SVGProps } from 'react';

const AllCategoriesIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			// 	width="100%"
			// 	height="100%"
			viewBox="0 0 19 19"
			fill="none"
			{...props}
		>
			<path
				d="M17.3392 1.71838L10.5516 0.521559C9.78819 0.386946 9.06017 0.896711 8.92556 1.66013L8.86133 2.02445C9.84293 2.14539 10.6722 2.85252 10.9333 3.82688L11.3481 5.37498C11.5678 5.27975 11.8167 5.24543 12.0701 5.29012C12.551 5.37491 12.9199 5.72096 13.0573 6.15644C13.3354 5.79422 13.8004 5.5952 14.2812 5.68C14.9694 5.80136 15.4289 6.45762 15.3076 7.1458C15.0439 8.64114 13.4393 9.84303 12.6778 10.3374L13.8404 14.6764C13.9027 14.909 13.9287 15.1428 13.923 15.3722L14.9012 15.5447C15.6646 15.6793 16.3926 15.1695 16.5272 14.4061L18.4777 3.3445C18.6123 2.58101 18.1026 1.853 17.3392 1.71838Z"
				fill="currentColor"
			/>
			<path
				d="M9.91721 4.09929C9.74916 3.47217 9.18206 3.05856 8.56229 3.05859C8.44205 3.05859 8.31978 3.07417 8.1981 3.10676L1.54071 4.89059C0.791913 5.09122 0.347538 5.8609 0.548175 6.60969L3.45528 17.4592C3.62333 18.0863 4.19043 18.4999 4.8102 18.4999C4.93044 18.4999 5.05271 18.4843 5.17435 18.4518L11.8317 16.6679C12.5805 16.4673 13.0249 15.6976 12.8243 14.9488L9.91721 4.09929ZM4.73669 11.5155C4.6238 11.4162 4.58165 11.2588 4.62975 11.1164L5.64773 8.10218C5.73288 7.85004 6.04725 7.7658 6.24707 7.94159L8.6358 10.043C8.74869 10.1423 8.79084 10.2997 8.74275 10.4421L7.72476 13.4564C7.63961 13.7085 7.32524 13.7928 7.12542 13.617L4.73669 11.5155Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default AllCategoriesIcon;
